// gatsby-browser.js runs on the CLIENT; gatsby-ssr.js runs during SSR.
// They are separate runtimes — each needs its own wrapRootElement, otherwise
// client-side <Helmet> usages crash with "Cannot read properties of undefined
// (reading 'add')" because there's no HelmetProvider context on the browser.
//
// NOTE: Bootstrap is loaded via SCSS (@import "~bootstrap/scss/bootstrap.scss"
// in src/assets/style.scss) so style.scss customizations (e.g. .btn-primary
// recoloured lime) can land afterwards. Re-importing the compiled
// bootstrap.min.css here would load it again later in the cascade and undo
// those overrides — Donate buttons would render Bootstrap's default blue.
import React from "react"
import { HelmetProvider } from "react-helmet-async"

export const wrapRootElement = ({ element }) => (
  <HelmetProvider>{element}</HelmetProvider>
)
